"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// JSON CONFIG _______________________________________________________
//
//
var _default = exports["default"] = function _default(settings, callbackHandler) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row,
      loadData = _ref.loadData,
      extraData = _ref.extraData;
    var targetingPawns = row['targetedByPawns.questprojectadminList'].map(function (item) {
      return item.pawn.pawnId;
    });
    var nonTargetingPawns = extraData['roles.questprojectadminList'].map(function (item) {
      return item.pawn.pawnId;
    });
    var allPawns = (0, _uniq2["default"])(targetingPawns.concat(nonTargetingPawns));
    var pawnNames = allPawns.map(function (item) {
      var match = row['targetedByPawns.questprojectadminList'].find(function (admin) {
        return admin.pawn.pawnId === item;
      });
      if (match) {
        return match.user.username;
      }
      var globalMatch = extraData['roles.questprojectadminList'].find(function (admin) {
        return admin.pawn.pawnId === item;
      });
      return globalMatch.user.username;
    });
    if (pawnNames.length === 0) {
      return /*#__PURE__*/_react["default"].createElement("div", null, allPawns.length);
    }
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: /*#__PURE__*/_react["default"].createElement("ul", {
        style: {
          padding: '0.5em 0 0.5em 0',
          margin: '0'
        }
      }, pawnNames.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("li", null, "\u2022 ", item);
      }))
    }, allPawns.length));
  };
};